import script from "./TopbarNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./TopbarNotification.vue?vue&type=script&setup=true&lang=js"

import "./TopbarNotification.vue?vue&type=style&index=0&id=61400978&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61400978"]])

export default __exports__